import { createReducer } from '@reduxjs/toolkit';
import { houseCall } from '../actions/anyRequests';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(houseCall.fulfilled, () => ({

  }));
});
